import type { ActivityViewProps } from '../../core/types/activity.types';
import { CartesianPlaneView } from './CartesianPlaneView';

export function CartesianPlaneActivityView(props: ActivityViewProps<'cartesian_plane'>) {
  return <CartesianPlaneView payload={props.payload} />;
}
